export enum CALENDAR_BTNS {
  THIS_WEEK = "This Week",
  LAST_WEEK = "Last Week",
  LAST_15_DAYS = "Last 15 days",
  CURRENT_MONTH = "Current Month",
  LAST_MONTH = "Last Month",
  RESET = "Reset",
}
